export default __webpack_public_path__ + "static/media/vp3_img.559428dd.jpg";